import React from 'react';
import { observer } from 'mobx-react';
import { ApiGeoUnitWithDayConstraints, ApiListOptions } from '@ibe/api';
import OverlayContainer from '../../Components/UI/LoadingOverlay/OverlayContainer';
import SearchCollapsible, {
  CollapsibleRef
} from '../../SubModules/SearchCollapsible/SearchCollapsible';
import Keys from '../../../_Translations/generated/camper.en.t.json.keys';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';
import { CamperSearch } from '../../SubModules/CamperSearch/CamperSearch';
import { CamperSearchParams } from '../../SubModules/CamperSearch/DefaultCamperSearchSchema';
import { removeQueries } from '../../Hooks/useHandleQueries';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/camper.en.t.json';
import CamperParams from '../../SubModules/CamperDetails/CamperParams';
import CamperStore from './CamperStore';
import useWindow from '../../Hooks/useWindow';
import { useWithFavoritesPortalContext } from '../../Hocs/useWithFavoritesPortalContext';

const SearchWidget = observer(function SearchWidget({
  collapsibleRef,
  searchParams,
  store,
  onSearch,
  setPickupGeoUnits,
  widgetClickable
}: {
  collapsibleRef?: CollapsibleRef;
  searchParams?: Partial<CamperParams>;
  onSearch?: (
    params: Partial<CamperSearchParams>,
    listOptions?: ApiListOptions,
    manualSearch?: boolean
  ) => void;
  store: CamperStore;
  setPickupGeoUnits?: (geoUnits: ApiGeoUnitWithDayConstraints[]) => void;
  widgetClickable?: boolean;
}) {
  const { t } = useTranslation('camper', fallback, Keys);
  const window = useWindow();
  const withFavoritesPortalContext = useWithFavoritesPortalContext();
  const currentSearchParams =
    !!searchParams && Object.keys(searchParams).length > 0 ? searchParams : store.searchParams;

  return (
    <OverlayContainer>
      <SearchCollapsible
        ref={collapsibleRef}
        collapseLabel={t(Keys.change)}
        widgetClickable={widgetClickable}
        searchContent={
          <>
            <div>
              {currentSearchParams?.pickupStationGeoUnit?.name ||
                currentSearchParams?.pickupStation ||
                ''}{' '}
              |{' '}
              {currentSearchParams?.dropOffStationGeoUnit?.name ||
                currentSearchParams?.dropOffStation ||
                ''}
            </div>
            <div>
              {currentSearchParams?.startDate && (
                <DateDisplay date={currentSearchParams.startDate} />
              )}
              {' - '}
              {currentSearchParams?.endDate && <DateDisplay date={currentSearchParams.endDate} />}
            </div>
          </>
        }
      >
        {!!withFavoritesPortalContext && (
          <div
            className="with-favorites-portal-container"
            ref={(element: HTMLDivElement) => withFavoritesPortalContext(element)}
          />
        )}
        <CamperSearch
          searchParams={currentSearchParams}
          onSubmit={(values: CamperSearchParams): void => {
            if (onSearch) {
              onSearch(values, store.listOptions, true);
            }
            removeQueries(window);
          }}
          setPickupGeoUnits={setPickupGeoUnits}
        />
      </SearchCollapsible>
    </OverlayContainer>
  );
});

export default SearchWidget;
